import React from "react";
import { useHits, useStats } from "react-instantsearch-core";
import ResultItem, { SearchData } from "./ResultItem";
import styles from "./SearchResults.module.css";

const Stats = () => {
  const { nbHits } = useStats();

  return (
    <div className={styles.resultsHeader}>
      We have <b>{nbHits}</b> items available
    </div>
  );
};

export const SearchResults = () => {
  const { hits } = useHits<SearchData>();

  return (
    <div className={styles.resultsContainer}>
      <Stats />
      {hits.map((item, index) => (
        <ResultItem key={index} data={item} />
      ))}
    </div>
  );
};
